import React from 'react';

import PropTypes from 'prop-types';

import { Text, TextGroup, Title } from '@asteria/component-core/typography';

import { Translation } from '@asteria/language';

/**
 * @typedef { import('../../../basic/types').Props } Props
 * @typedef { import('../../../basic/types').ChildrenProps } ChildrenProps
 */

/** @type { React.FC<ChildrenProps & { type: string, translationData: ReturnType<typeof useTranslationData>, section: string }> } */
const SectionBox = function Box(props) {
	const { translationOptions, type, translationData, section } = props;

	return (
		<div className="border border-solid border-border-normal rounded flex flex-col gap-2 p-4">
			<Translation
				translationKey="card.content.box.title"
				translationOptions={{
					...translationOptions,
					postfix: {
						...translationOptions?.postfix,
						currency: type,
						section: section,
					},
					data: {
						...translationOptions?.data,
						selected: translationData,
					},
				}}
				Component={Text}
			/>
			<TextGroup>
				<Translation
					translationKey="card.content.box.content"
					translationOptions={{
						...translationOptions,
						postfix: {
							...translationOptions?.postfix,
							currency: type,
							section: section,
						},
						data: {
							...translationOptions?.data,
							selected: translationData,
						},
					}}
					Component={Title}
					size="xs"
				/>
				{type &&
				translationData?.original?.[section] &&
				translationData?.original?.currency !==
					translationData?.display?.currency ? (
					<Translation
						translationKey="card.content.box.sub-content"
						translationOptions={{
							...translationOptions,
							postfix: {
								...translationOptions?.postfix,
								currency: type,
								section: section,
							},
							data: {
								...translationOptions?.data,
								selected: translationData,
							},
						}}
						Component={Text}
						size="sm"
						weight="light"
					/>
				) : null}
			</TextGroup>
		</div>
	);
};

SectionBox.propTypes = {
	translationOptions: PropTypes.object,
	type: PropTypes.string,
	translationData: PropTypes.shape({
		display: PropTypes.object,
		original: PropTypes.object,
		count: PropTypes.number,
	}),
	section: PropTypes.string,
};

export default SectionBox;
